import { Component } from '@angular/core';
import { HeroComponent } from '../../shared/hero/hero.component';
import { Article } from '../../../models/article';
import { FirestoreService } from '../../../services/firestore/firestore.service';
import { SharedService } from '../../../services/shared/shared.service';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-article',
  imports: [HeroComponent,CommonModule,RouterLink],
  templateUrl: './article.component.html',
  styleUrl: './article.component.css'
})
export class ArticleComponent {
  articles: Article[] = [];
    showSpinner = true;

  constructor(
    private firestoreService:FirestoreService,
    private sharedService:SharedService
  ){
  
  }
getPlainContent(content: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');

  // Replace <br> with newlines
  doc.body.querySelectorAll("br").forEach(br => br.replaceWith("\n"));

  // Add newlines after paragraphs
  doc.body.querySelectorAll("p").forEach(p => {
    p.insertAdjacentText("beforeend", "\n\n");
  });
  let finleCentent=(doc.body.textContent || "").trim();
  return finleCentent.slice(0,80)+"...";
}

  ngOnInit(){
    this.getAllArticles();
  }
 getAllArticles() {
    this.firestoreService.getAll('articles').subscribe({
      next: (data) => {
        this.articles = data;
          this.showSpinner = false;

      },
      error: (error) => {
          this.showSpinner = false;

        this.sharedService.handleError(error, undefined, "Error fetching articles.");
      }
    });
  }
}
